import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

export const Label = styled(Typo.Text)`
  width: fit-content;
  padding: 4px 6px;
  border-radius: 4px;

  background-color: ${grayScale.main};
`;
